import(/* webpackMode: "eager", webpackExports: ["APIProvider"] */ "/app/app/(providers)/APIProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(providers)/AuthBootstrap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigBootstrap"] */ "/app/app/(providers)/ConfigBootstrap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationInit"] */ "/app/app/(providers)/NotificationInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["XMPPInit"] */ "/app/app/(providers)/XMPPInit.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@digivox/design-system-smartspace/dist/dist/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
